"use client";

import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";

const AboutWelcome: React.FC = () => {
    const [openVideo, setOpenVideo] = useState(false);

    return (
        <section className="about-area py-0">
            <div className="container">
                <div className="row">
                    {/* Left Content */}
                    <div >
                        <div className="single-about">
                            <div className="about-img ">
                                <Image
                                    src="/images/about-img.png"
                                    alt="about"
                                    fill
                                    className="img-fluid relative"
                                />
                            </div>

                            <div className="about-contnet">
                                <h2>Welcome to Cayman Academy</h2>
                                <p>
                                    It is with great pleasure that we welcome you to our school community. At Cayman Academy, we are proud to be recognized as one of the leading schools in the Cayman Islands. Our commitment is to provide an environment where every student can grow, achieve, and maximize his or her full potential.
                                </p>
                                <p>
                                    We believe that education is most successful when schools and families work together. As partners in your child’s journey, we look forward to collaborating with you to ensure the very best educational experience. Every decision we make is guided by what is in the best interest of our students.
                                </p>
                                <p>
                                    Together, we will continue striving to make Cayman Academy not only one of the best schools in the Cayman Islands, but one of the best anywhere.
                                </p>

                                <div className="mt-4">
                                    <h3>To The Parents</h3>
                                    <p>
                                        We think that well-informed parents promote a positive school environment. Consistent with this philosophy, we are requiring that your child bring home a copy of the Student Handbook or download it from our website so that you may become acquainted with the various phases of school life. In this handbook, you should note that we have included regulations, the Code of Student Conduct, activities, clubs, and general information which will aid a student in becoming a productive member of the school community.
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <h3>To The Students</h3>
                                    <p>
                                        This handbook has been developed to help you understand the policies, procedures, and opportunities available at our school. We hope it supports you in making your school experience both pleasant and productive.
                                    </p>
                                    <p>
                                        Students and parents are expected to read, understand, and follow the guidelines outlined in the handbook. Please note that policies may be updated as needed by the School Board or school administration. Any changes will be communicated and posted on the school website.
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <h3>How the School is administered</h3>
                                    <p>The school has three divisions:</p>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><strong>Early Childhood:</strong> Pre kindergarten and Kindergarten</li>
                                        <li className="mb-2"><strong>Primary:</strong> Years: 1 – 6</li>
                                        <li className="mb-2"><strong>High School:</strong> Years 7 - 12</li>
                                    </ul>
                                </div>
                            </div>

                            {/* <div className="about-btn">
                                <Link href="/contact" className="box-btn">
                                    Know More
                                </Link>

                                <button
                                    type="button"
                                    className="video-pop customebtn"
                                    onClick={() => setOpenVideo(true)}
                                >
                                    <span className="video">
                                        <i className="fa fa-play"></i>
                                    </span>
                                    Quick View at Cayman Academy
                                </button>
                            </div> */}
                        </div>
                    </div>


                </div>
            </div>
            {/* Video Modal */}
            {openVideo && (
                <div className="video-modal">
                    <div className="video-modal-content">
                        <button
                            className="close-btn"
                            onClick={() => setOpenVideo(false)}
                        >
                            ✕
                        </button>

                        {/* <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/_ysd-zHamjk?autoplay=1"
                            title="YouTube video"
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                        /> */}
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/gyppp0oT6ng"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            )}

        </section>
    );
};

export default AboutWelcome;

